import { render, staticRenderFns } from "./CuentaNuevaDestino.vue?vue&type=template&id=58bdb635&scoped=true"
import script from "./CuentaNuevaDestino.vue?vue&type=script&lang=js"
export * from "./CuentaNuevaDestino.vue?vue&type=script&lang=js"
import style0 from "./CuentaNuevaDestino.vue?vue&type=style&index=0&id=58bdb635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bdb635",
  null
  
)

export default component.exports